// src/store/services/users.js
import feathersClient, {
  makeServicePlugin,
  BaseModel,
} from "../../feathers-client";

class TotemUsers extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "TotemUsers";
  // Define default properties here
  static instanceDefaults() {
    return {
      _id: "",
      name: "",
      email: "",
      password: "",
      roles: [],
      addresses: [],
      payment_method: [],
      loyalty: {},
      isVerified: true,
    };
  }
}
const servicePath = "admin/totem-users";
const servicePlugin = makeServicePlugin({
  Model: TotemUsers,
  service: feathersClient.service(servicePath),
  servicePath,
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
});

export default servicePlugin;
